// Checks Reducer

const probersReducerDefaultState = [];

export default (state = probersReducerDefaultState, action) => {
  switch (action.type) {
    case "SET_PROBERS":
      return action.probers;
    default:
      return state;
  }
};
